<template>
  <div class="welcome-container">
    <div class="header-container">
      <div class="info-header">
        <div class="screen-container">
          <div class="table-layout" style="height: inherit;padding: 10px 0;">
            <div class="table-layout-cell left" style="vertical-align: top;">
              <div class="header-title">
                <img src="/static/images/header/logo.png" style="width: 138px;margin-top: 11px;">
              </div>
              <div class="header-introduce">{{ introduce }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="router-header"></div>
    </div>

    <div class="main-container screen-container left">
      <component :is="tab" @change="changeHandler" style="padding-top: 100px;" />
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import welcomeOne from './one.vue'
import welcomeTwo from './two.vue'

const introduce = ref('M4300-52G-Poe+')

const tab = ref(welcomeOne)

const changeHandler = (newTab) => {
  console.log("changeHandler clicked", newTab)

  if (newTab === 'welcomeTwo') {
    tab.value = welcomeTwo
  } else {
    tab.value = welcomeOne
  }
}
</script>